import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';

const mapStateToProps = ({ authentication }) => ({
    auth: authentication,
});

const AuthorizedRoute = ({ auth = {}, children }) =>
    auth.authenticated ? children : <Navigate to="/auth/login" replace />;

AuthorizedRoute.propTypes = {
    auth: PropTypes.shape({}),
    children: PropTypes.node,
};

export default connect(mapStateToProps)(AuthorizedRoute);
